<template>
    <label
        class="checkbox"
        :class="{ 'disabled': disabled }"
        @click.prevent="toggle"
    >
        <input
            type="checkbox"
            :value="value"
            :checked="toggled"
            :name="name"
            :disabled="disabled"
        >
        <span />
        <slot />
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'toggled',
            event: 'toggle',
        },
        props: {
            toggled: {
                type: Boolean,
                default: false,
            },
            name: {
                type: String,
                default: null,
            },
            value: {
                type: [String, Number],
                default: null,
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        methods: {
            toggle() {
                this.$emit('toggle', ! this.toggled);
            },
        },
    };
</script>